import { IEconomicsSettingsFacilityInput } from '../../interfaces/ieconomics-settings-facility-input';
import { EconomicsSetting } from '../economics-setting';

export class EconomicsSettingsFacilityInputBase {
  EconomicsSettingsFacilityInputId: number;
  EconomicsSettingId: number;
  AverageFacilityAmountPerWell: number | null;
  WellCountStart: number | null;
  WellCountEnd: number | null;
  SortOrder: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  EconomicsSetting?: EconomicsSetting;

  constructor(item?: IEconomicsSettingsFacilityInput) {
    if (item) {

      this.EconomicsSettingsFacilityInputId = item.EconomicsSettingsFacilityInputId;
      this.EconomicsSettingId = item.EconomicsSettingId;
      this.AverageFacilityAmountPerWell = item.AverageFacilityAmountPerWell;
      this.WellCountStart = item.WellCountStart;
      this.WellCountEnd = item.WellCountEnd;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.EconomicsSetting = new EconomicsSetting(item.EconomicsSetting);
    }
  }
}